/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unavailable_Sign_OutInputs */



/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Unavailable_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const unavailable_sign_out = /** @type {((inputs?: Unavailable_Sign_OutInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unavailable_Sign_OutInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Afmelden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se déconnecter")
	return /** @type {LocalizedString} */ ("Sign out")
});